import axios from 'axios'
require('dotenv').config()
const baseUrl = process.env.REACT_APP_API_BASE_PATH;

const uploadImage = (enpoint, dataForm, conf=null) => (axios.post(`${baseUrl}/${enpoint}`, dataForm, conf))

export default uploadImage
